// External references cited in the interface

/** EU Horizon 2020 Work Programme 2014–2015, General Annexes, Part G: Technology readiness levels. */
export const TRL_SCALE_URL =
  "https://ec.europa.eu/research/participants/data/ref/h2020/wp/2014_2015/annexes/h2020-wp1415-annex-g-trl_en.pdf";
